/**
 * FAQ模块
 */
import faqApi from '../../api/faq.api'

const state = {
    dataList: [],
    randomTime: new Date().getTime(),
};

const getters = {};

const mutations = {
    setList(state, data) {
        state.dataList = data;
    }
};

const actions = {
    getList({state, commit, rootState}) {
        return state.dataList.length ? Promise.resolve(state.dataList) : faqApi.getList(rootState.user._id).then(res => {
            commit('setList', res);
            return res;
        })
    },
    getArticleClassify({dispatch}) {
        return dispatch('getList').then(() => {
            let data = [];
            for (let classify of state.dataList) {
                if (classify.type !== 2) {
                    classify.children.forEach(item => {
                        item.classifyName = classify.title;
                        data.push(item);
                    });
                }
            }
            return data;
        })
    },
    getItem({}, id) {
        return faqApi.getItem(id);
    },
    classify ({commit},params) {
        return faqApi.classify(params);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/faq.js